import * as React from "react";
import { SingleNavMenuLinkPage as ISingleNavMenuLinkPage } from "../../../pages/identity/useNavMenu";
import { useNavigate } from "react-router-dom";
import { BasePathContext } from "../../../reactContexts/basePathContext";
import { useSingleNavMenuContext } from "./useSingleNavMenuContext";
import clsx from "clsx";
import { CpErrorWarningArrayIconLink } from "../../../pages/gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpDirtyIndicatorArrayIconLink } from "../../../pages/gvc/testNewForm/CpDirtyIndicatorArrayIconLink";

interface Props {
  link: ISingleNavMenuLinkPage;
  index: number;
}
export const SingleNavMenuLinkPage: React.FC<Props> = ({ link, index }) => {
  const basePath = React.useContext(BasePathContext);
  const navigate = useNavigate();
  const { activeLinkId } = useSingleNavMenuContext();

  const href = React.useMemo(() => {
    return `${basePath}${link.page}`;
  }, [basePath, link, link.page]);

  return (
    <a
      data-link-id={`${link.id}`}
      className={clsx("relative", {
        sublevel_1: link.subLevel === 1,
        sublevel_2: link.subLevel === 2,
        active: activeLinkId === link.id,
      })}
      onClick={(e) => {
        if (e.button === 1 || e.ctrlKey || e.metaKey) {
          return;
        }

        e.preventDefault();
        navigate(href, { replace: true });
      }}
      href={href}
    >
      {link.label}
      {link.renderIcon ? link.renderIcon() : null}
      {link.names && link.names.length > 0 ? <CpErrorWarningArrayIconLink names={link.names} /> : null}
      {link.showDirty ? (
        link.names && link.names.length > 0 ? (
          <CpDirtyIndicatorArrayIconLink names={link.names} />
        ) : null
      ) : null}
    </a>
  );
};
